import SimpleLightbox from 'simplelightbox';

export default function initGallery() {

    window.addEventListener('load', function () {

        const $containers = document.querySelectorAll('.slider-container');

        $containers.forEach($container => {

            if ($container.classList.contains('custom-slider')) {
                $container.querySelectorAll('.image').forEach($imageContainer => {
                    const $img = $imageContainer.querySelector('img');
                    const $imgSrc = $img.src !== undefined && $img.src !== null ?  $img.src : '' ;
                    const $imgAlt = $img.alt !== undefined && $img.alt !== null ?  $img.alt : '' ;
                    $img.remove();

                    let $imagLightbox = document.createElement('a');
                    $imagLightbox.appendChild($img);
                    $imagLightbox.title = $imgAlt;
                    $imagLightbox.href = $imgSrc;
                    $imageContainer.appendChild($imagLightbox);
                })
            }

            const lightboxClass = $container.classList.contains('is-primary') ? 'lightbox-is-primary' : 'lightbox-is-secondary';
            const $lightbox = $container.querySelectorAll('.swiper-wrapper a');

            const right = ' <svg id="icon-chevron-right-solid" viewBox="0 0 192 512">\n' +
                '        <path fill="currentColor"\n' +
                '              d="M187.8 264.5L41 412.5c-4.7 4.7-12.3 4.7-17 0L4.2 392.7c-4.7-4.7-4.7-12.3 0-17L122.7 256 4.2 136.3c-4.7-4.7-4.7-12.3 0-17L24 99.5c4.7-4.7 12.3-4.7 17 0l146.8 148c4.7 4.7 4.7 12.3 0 17z"\n' +
                '              class=""></path>\n' +
                '    </svg>';

            const left = right;

            let lightbox = new SimpleLightbox($lightbox, {
                //fileExt: false,
                scrollZoom: false,
                captionSelector: "self",
                showCounter: false,
                navText: [left, right],
                overlayOpacity: "0.8",
                captions: false,
                enableKeyboard: true,
                loop: false,
                htmlClass: 'lightbox-is-open',
                className: lightboxClass,
                scaleImageToRatio: true
            });
        });
    });
}
